<template>
  <el-container
    class="container-list is-vertical"
    style="height: 100%; width: 100%; position: fixed;">
    <top-header>
      <template slot="left">
        <el-input
          @keyup.enter.native="search"
          @input="delaySearch"
          style="width: 240px;"
          placeholder="搜尋標題"
          v-model="keyword"
          class="input-with-select">
          <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
        </el-input>

        <el-select
          v-model="filteringStatus"
          @change="search"
          placeholder="篩選狀態"
          style="width: 120px;margin-left: 10px;">
          <el-option label="全部" value="全部" />
          <el-option label="已發佈" value="已發佈" />
          <el-option label="草稿" value="草稿" />
        </el-select>
      </template>
      <template slot="right">
        <el-button @click="$router.push({ name: 'createWork' })" style="margin-right: 20px;">新增</el-button>
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading">
        <el-table :data="tableData" stripe height="calc(100% - 40px)">
          <template slot="empty">沒有資料</template>

          <el-table-column label="封面" width="60px">
            <template slot-scope="scope">
              <img
                :src="scope.row.CoverImageUrl"
                class="w-100"/>
            </template>
          </el-table-column>

          <el-table-column label="標題" min-width="120px">
            <template slot-scope="scope">{{scope.row.Title}}</template>
          </el-table-column>
          <el-table-column label="作品日期" width="130px">
            <template slot-scope="scope">{{scope.row.Date | dateFormat}}</template>
          </el-table-column>
          <el-table-column label="最後更新時間" width="170px">
            <template slot-scope="scope">{{scope.row.UpdatedAt | moment}}</template>
          </el-table-column>
          <el-table-column label="狀態" width="70px">
            <template slot-scope="scope">
              <p v-if="scope.row.IsActive" class="deployed">發佈</p>
              <p v-else class="draft">草稿</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                round
                @click="$router.push({ name: 'updateWork', params: { id: scope.row.ID }})">
                編輯
              </el-button>

              <el-button
                size="mini"
                round
                @click="openDetailPage(scope.row)">
                預覽
              </el-button>

              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                circle
                @click="askToDelete(scope.$index, scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          layout="prev, pager, next"
          :currentPage="currentPage"
          :page-size="20"
          :total="searchedObjs.length"
          @current-change="onChangePage"
        ></el-pagination>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import moment from 'moment'
import LeftMenu from '@/components/LeftMenu.vue'
import TopHeader from '@/components/TopHeader.vue'
// svgs
import '@/assets/svgs/index.js'

export default {
  components: {
    LeftMenu,
    TopHeader
  },
  data () {
    return {
      searchedObjs: [],
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      searchTimer: null,
      keyword: '',
      filteringStatus: null,
      filteringDateRange: null
    }
  },
  computed: {},
  methods: {
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 20, page * 20)
    },
    delaySearch () {
      if (this.searchTimer !== null) window.clearTimeout(this.searchTimer)
      this.searchTimer = window.setTimeout(() => {
        this.searchTimer = null
        this.search()
      }, 500)
    },
    search () {
      if (this.searchTimer !== null) window.clearTimeout(this.searchTimer)
      this.searchTimer = null
      this.filterObjs()
      this.tableData = this.searchedObjs.slice(0, 20)
      this.currentPage = 1
      this.alertSearchResult()
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange) {
        this.searchedObjs = this.$store.state.work.list
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        let isTitleFit = o.Title && o.Title.includes(this.keyword)
        return isTitleFit
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        return o.IsActive === (this.filteringStatus === '已發佈')
      }

      this.searchedObjs = this.$store.state.work.list.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u)
      })
    },
    alertSearchResult () {
      if (this.searchedObjs.length > 0) {
        this.$message({
          message: `搜尋結果共${this.searchedObjs.length}筆符合條件`,
          duration: 1000
        })
      } else {
        this.$message({
          message: '查無符合條件',
          duration: 1000
        })
      }
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除 ${obj.Title} ?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.work.delete(this, obj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.$store.state.work.list.findIndex(o => o.ID === obj.ID)
          if (idx >= 0) this.$store.state.work.list.splice(idx, 1)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * 20,
            this.currentPage * 20
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      })
    },
    openDetailPage (obj) {
      let urlKey = encodeURIComponent(obj.UrlKey)
      let url = `https://codus.me/work/${urlKey}`
      window.open(url)
    }
  },
  created () {
    const initTableData = () => {
      this.searchedObjs = this.$store.state.work.list
      this.tableData = this.searchedObjs.slice(0, 20)
    }

    if (
      !this.$store.state.work.isFetched &&
      !this.$store.state.work.isFetching
    ) {
      this.$services.fetchWorkDatas(this).then(initTableData)
    } else {
      initTableData()
    }
  },
  filters: {
    moment (str) {
      return moment(str).format('LLL')
    },
    dateFormat (str) {
      return moment(str).format('YYYY年MM月DD日')
    }
  }
}
</script>

<style>
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
</style>
